export const dateFormat = 'YYYY-MM-DDTHH:mm:ss';

export const crmDateFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

/**
 * Restituisce la descrizione del tipo di fornitura basata su un valore numerico.
 *
 * @param {number} tipoFornitura - Il codice numerico che rappresenta il tipo di fornitura.
 * @returns {string} La descrizione del tipo di fornitura corrispondente al codice numerico.
 */
export const getTipoFornitura = (tipoFornitura: number) => {
  switch (tipoFornitura) {
    case 0:
      return 'Occhiale correttivo completo'; // Fornitura di occhiali con lenti correttive e montatura.
    case 1:
      return 'Occhiale da sole'; // Fornitura di occhiali da sole, senza correzione.
    case 2:
      return 'Sostituzione lenti'; // Servizio di sostituzione delle sole lenti.
    case 3:
      return 'Sosituzione montatura'; // Servizio di sostituzione della sola montatura.
    case 4:
      return 'Interventi manutenzione'; // Servizi di manutenzione per occhiali.
    case 8:
      return 'Fornitura generica'; // Fornitura non specificata di prodotti o servizi.
    case 10:
      return 'Fornitura LAC'; // Fornitura di Lenti a Contatto.
  }
  return ''; // Se il codice non corrisponde, restituisce una stringa vuota.
};

/**
 * Restituisce la descrizione del tipo di pagamento basata su un valore numerico.
 *
 * @param {number} tipoVisualizzazione - il valore per la select che gestisce la finestra temporale da visualizzare.
 * @returns {string} La descrizione della finestra temporale.
 */
export const VISUALIZZAZIONE_TUTTI = 5;
export const VISUALIZZAZIONE_PER_PERIODO = 1;
export const VISUALIZZAZIONE_GIORNALIERA = 2;
export const VISUALIZZAZIONE_SETTIMANALE = 3;
export const VISUALIZZAZIONE_MENSILE = 4;
export type TipoVisualizzazione = 1 | 2 | 3 | 4 | 5;
export const getTipoVisualizzazione = (tipoVisualizzazione: number) => {
  switch (tipoVisualizzazione) {
    case VISUALIZZAZIONE_PER_PERIODO:
      return 'Per periodo';
    case VISUALIZZAZIONE_GIORNALIERA:
      return 'Giornaliera';
    case VISUALIZZAZIONE_SETTIMANALE:
      return 'Settimanale';
    case VISUALIZZAZIONE_MENSILE:
      return 'Mensile';
    default:
    case VISUALIZZAZIONE_TUTTI:
      return '(Tutti i movimenti)';
  }
};

export const showNumberFieldError = {
  width: '50% !important',
  backgroundColor: 'red !important',
  height: '0px !important',
  borderBottom: '2px solid var(--alert-color)',
  borderRadius: 'unset !important',
};

export const networkErrorString = 'Errore di connessione al server.';

export const lockedRecordString =
  'Non è possibile modificare la scheda selezionata perchè è attualmente in stato di modifica in un altro terminale.';

export const listaMesi = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
];

export const sxAbsoluteSize = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

export interface Stati {
  stato: string;
  codiceStato: string;
}

export const stati: Stati[] = [
  {
    stato: 'Afghanistan',
    codiceStato: 'AF',
  },
  {
    stato: 'Aland',
    codiceStato: 'AX',
  },
  {
    stato: 'Albania',
    codiceStato: 'AL',
  },
  {
    stato: 'Algeria',
    codiceStato: 'DZ',
  },
  {
    stato: 'American Samoa',
    codiceStato: 'AS',
  },
  {
    stato: 'Andorra',
    codiceStato: 'AD',
  },
  {
    stato: 'Angola',
    codiceStato: 'AO',
  },
  {
    stato: 'Anguilla',
    codiceStato: 'AI',
  },
  {
    stato: 'Antarctica',
    codiceStato: 'AQ',
  },
  {
    stato: 'Antigua and Barbuda',
    codiceStato: 'AG',
  },
  {
    stato: 'Argentina',
    codiceStato: 'AR',
  },
  {
    stato: 'Armenia',
    codiceStato: 'AM',
  },
  {
    stato: 'Aruba',
    codiceStato: 'AW',
  },
  {
    stato: 'Ascension',
    codiceStato: 'AC',
  },
  {
    stato: 'Australia',
    codiceStato: 'AU',
  },
  {
    stato: 'Austria',
    codiceStato: 'AT',
  },
  {
    stato: 'Azerbaijan',
    codiceStato: 'AZ',
  },
  {
    stato: 'Bahamas',
    codiceStato: 'BS',
  },
  {
    stato: 'Bahrain',
    codiceStato: 'BH',
  },
  {
    stato: 'Bangladesh',
    codiceStato: 'BD',
  },
  {
    stato: 'Barbados',
    codiceStato: 'BB',
  },
  {
    stato: 'Belarus',
    codiceStato: 'BY',
  },
  {
    stato: 'Belgium',
    codiceStato: 'BE',
  },
  {
    stato: 'Belize',
    codiceStato: 'BZ',
  },
  {
    stato: 'Benin',
    codiceStato: 'BJ',
  },
  {
    stato: 'Bermuda',
    codiceStato: 'BM',
  },
  {
    stato: 'Bhutan',
    codiceStato: 'BT',
  },
  {
    stato: 'Bolivia',
    codiceStato: 'BO',
  },
  {
    stato: 'Bosnia and Herzegovina',
    codiceStato: 'BA',
  },
  {
    stato: 'Botswana',
    codiceStato: 'BW',
  },
  {
    stato: 'Bouvet Island',
    codiceStato: 'BV',
  },
  {
    stato: 'Brazil',
    codiceStato: 'BR',
  },
  {
    stato: 'British Indian Ocean Territory',
    codiceStato: 'IO',
  },
  {
    stato: 'British Virgin Islands',
    codiceStato: 'VG',
  },
  {
    stato: 'Brunei',
    codiceStato: 'BN',
  },
  {
    stato: 'Bulgaria',
    codiceStato: 'BG',
  },
  {
    stato: 'Burkina Faso',
    codiceStato: 'BF',
  },
  {
    stato: 'Burundi',
    codiceStato: 'BI',
  },
  {
    stato: 'Cambodia',
    codiceStato: 'KH',
  },
  {
    stato: 'Cameroon',
    codiceStato: 'CM',
  },
  {
    stato: 'Canada',
    codiceStato: 'CA',
  },
  {
    stato: 'Cape Verde',
    codiceStato: 'CV',
  },
  {
    stato: 'Cayman Islands',
    codiceStato: 'KY',
  },
  {
    stato: 'Central African Republic',
    codiceStato: 'CF',
  },
  {
    stato: 'Chad',
    codiceStato: 'TD',
  },
  {
    stato: 'Chile',
    codiceStato: 'CL',
  },
  {
    stato: 'China',
    codiceStato: 'CN',
  },
  {
    stato: 'Christmas Island',
    codiceStato: 'CX',
  },
  {
    stato: 'Cocos (Keeling) Islands',
    codiceStato: 'CC',
  },
  {
    stato: 'Colombia',
    codiceStato: 'CO',
  },
  {
    stato: 'Comoros',
    codiceStato: 'KM',
  },
  {
    stato: 'Cook Islands',
    codiceStato: 'CK',
  },
  {
    stato: 'Costa Rica',
    codiceStato: 'CR',
  },
  {
    stato: "Cote d'Ivoire (Ivory Coast)",
    codiceStato: 'CI',
  },
  {
    stato: 'Croatia',
    codiceStato: 'HR',
  },
  {
    stato: 'Cuba',
    codiceStato: 'CU',
  },
  {
    stato: 'Cyprus',
    codiceStato: 'CY',
  },
  {
    stato: 'Czech Republic',
    codiceStato: 'CZ',
  },
  {
    stato: 'Denmark',
    codiceStato: 'DK',
  },
  {
    stato: 'Djibouti',
    codiceStato: 'DJ',
  },
  {
    stato: 'Dominica',
    codiceStato: 'DM',
  },
  {
    stato: 'Dominican Republic',
    codiceStato: 'DO',
  },
  {
    stato: 'Ecuador',
    codiceStato: 'EC',
  },
  {
    stato: 'Egypt',
    codiceStato: 'EG',
  },
  {
    stato: 'El Salvador',
    codiceStato: 'SV',
  },
  {
    stato: 'Equatorial Guinea',
    codiceStato: 'GQ',
  },
  {
    stato: 'Eritrea',
    codiceStato: 'ER',
  },
  {
    stato: 'Estonia',
    codiceStato: 'EE',
  },
  {
    stato: 'Ethiopia',
    codiceStato: 'ET',
  },
  {
    stato: 'Falkland Islands (Islas Malvinas)',
    codiceStato: 'FK',
  },
  {
    stato: 'Faroe Islands',
    codiceStato: 'FO',
  },
  {
    stato: 'Fiji',
    codiceStato: 'FJ',
  },
  {
    stato: 'Finland',
    codiceStato: 'FI',
  },
  {
    stato: 'France',
    codiceStato: 'FR',
  },
  {
    stato: 'French Guiana',
    codiceStato: 'GF',
  },
  {
    stato: 'French Polynesia',
    codiceStato: 'PF',
  },
  {
    stato: 'French Southern and Antarctic Lands',
    codiceStato: 'TF',
  },
  {
    stato: 'Gabon',
    codiceStato: 'GA',
  },
  {
    stato: 'Gambia',
    codiceStato: 'The',
  },
  {
    stato: 'Georgia',
    codiceStato: 'GE',
  },
  {
    stato: 'Germany',
    codiceStato: 'DE',
  },
  {
    stato: 'Ghana',
    codiceStato: 'GH',
  },
  {
    stato: 'Gibraltar',
    codiceStato: 'GI',
  },
  {
    stato: 'Greece',
    codiceStato: 'GR',
  },
  {
    stato: 'Greenland',
    codiceStato: 'GL',
  },
  {
    stato: 'Grenada',
    codiceStato: 'GD',
  },
  {
    stato: 'Guadeloupe',
    codiceStato: 'GP',
  },
  {
    stato: 'Guam',
    codiceStato: 'GU',
  },
  {
    stato: 'Guatemala',
    codiceStato: 'GT',
  },
  {
    stato: 'Guernsey',
    codiceStato: 'GG',
  },
  {
    stato: 'Guinea',
    codiceStato: 'GN',
  },
  {
    stato: 'Guinea-Bissau',
    codiceStato: 'GW',
  },
  {
    stato: 'Guyana',
    codiceStato: 'GY',
  },
  {
    stato: 'Haiti',
    codiceStato: 'HT',
  },
  {
    stato: 'Heard Island and McDonald Islands',
    codiceStato: 'HM',
  },
  {
    stato: 'Honduras',
    codiceStato: 'HN',
  },
  {
    stato: 'Hong Kong',
    codiceStato: 'HK',
  },
  {
    stato: 'Hungary',
    codiceStato: 'HU',
  },
  {
    stato: 'Iceland',
    codiceStato: 'IS',
  },
  {
    stato: 'India',
    codiceStato: 'IN',
  },
  {
    stato: 'Indonesia',
    codiceStato: 'ID',
  },
  {
    stato: 'Iran',
    codiceStato: 'IR',
  },
  {
    stato: 'Iraq',
    codiceStato: 'IQ',
  },
  {
    stato: 'Ireland',
    codiceStato: 'IE',
  },
  {
    stato: 'Isle of Man',
    codiceStato: 'IM',
  },
  {
    stato: 'Israel',
    codiceStato: 'IL',
  },
  {
    stato: 'Italia',
    codiceStato: 'IT',
  },
  {
    stato: 'Jamaica',
    codiceStato: 'JM',
  },
  {
    stato: 'Japan',
    codiceStato: 'JP',
  },
  {
    stato: 'Jersey',
    codiceStato: 'JE',
  },
  {
    stato: 'Jordan',
    codiceStato: 'JO',
  },
  {
    stato: 'Kazakhstan',
    codiceStato: 'KZ',
  },
  {
    stato: 'Kenya',
    codiceStato: 'KE',
  },
  {
    stato: 'Kiribati',
    codiceStato: 'KI',
  },
  {
    stato: 'Kosovo',
    codiceStato: 'XK',
  },
  {
    stato: 'Kuwait',
    codiceStato: 'KW',
  },
  {
    stato: 'Kyrgyzstan',
    codiceStato: 'KG',
  },
  {
    stato: 'Laos',
    codiceStato: 'LA',
  },
  {
    stato: 'Latvia',
    codiceStato: 'LV',
  },
  {
    stato: 'Lebanon',
    codiceStato: 'LB',
  },
  {
    stato: 'Lesotho',
    codiceStato: 'LS',
  },
  {
    stato: 'Liberia',
    codiceStato: 'LR',
  },
  {
    stato: 'Libya',
    codiceStato: 'LY',
  },
  {
    stato: 'Liechtenstein',
    codiceStato: 'LI',
  },
  {
    stato: 'Lithuania',
    codiceStato: 'LT',
  },
  {
    stato: 'Luxembourg',
    codiceStato: 'LU',
  },
  {
    stato: 'Macau',
    codiceStato: 'MO',
  },
  {
    stato: 'Macedonia',
    codiceStato: 'MK',
  },
  {
    stato: 'Madagascar',
    codiceStato: 'MG',
  },
  {
    stato: 'Malawi',
    codiceStato: 'MW',
  },
  {
    stato: 'Malaysia',
    codiceStato: 'MY',
  },
  {
    stato: 'Maldives',
    codiceStato: 'MV',
  },
  {
    stato: 'Mali',
    codiceStato: 'ML',
  },
  {
    stato: 'Malta',
    codiceStato: 'MT',
  },
  {
    stato: 'Marshall Islands',
    codiceStato: 'MH',
  },
  {
    stato: 'Martinique',
    codiceStato: 'MQ',
  },
  {
    stato: 'Mauritania',
    codiceStato: 'MR',
  },
  {
    stato: 'Mauritius',
    codiceStato: 'MU',
  },
  {
    stato: 'Mayotte',
    codiceStato: 'YT',
  },
  {
    stato: 'Mexico',
    codiceStato: 'MX',
  },
  {
    stato: 'Micronesia',
    codiceStato: 'FM',
  },
  {
    stato: 'Moldova',
    codiceStato: 'MD',
  },
  {
    stato: 'Monaco',
    codiceStato: 'MC',
  },
  {
    stato: 'Mongolia',
    codiceStato: 'MN',
  },
  {
    stato: 'Montenegro',
    codiceStato: 'ME',
  },
  {
    stato: 'Montserrat',
    codiceStato: 'MS',
  },
  {
    stato: 'Morocco',
    codiceStato: 'MA',
  },
  {
    stato: 'Mozambique',
    codiceStato: 'MZ',
  },
  {
    stato: 'Myanmar (Burma)',
    codiceStato: 'MM',
  },
  {
    stato: 'Namibia',
    codiceStato: 'NA',
  },
  {
    stato: 'Nauru',
    codiceStato: 'NR',
  },
  {
    stato: 'Nepal',
    codiceStato: 'NP',
  },
  {
    stato: 'Netherlands Antilles',
    codiceStato: 'AN',
  },
  {
    stato: 'Netherlands',
    codiceStato: 'NL',
  },
  {
    stato: 'New Caledonia',
    codiceStato: 'NC',
  },
  {
    stato: 'New Zealand',
    codiceStato: 'NZ',
  },
  {
    stato: 'Nicaragua',
    codiceStato: 'NI',
  },
  {
    stato: 'Niger',
    codiceStato: 'NE',
  },
  {
    stato: 'Nigeria',
    codiceStato: 'NG',
  },
  {
    stato: 'Niue',
    codiceStato: 'NU',
  },
  {
    stato: 'Norfolk Island',
    codiceStato: 'NF',
  },
  {
    stato: 'Northern Mariana Islands',
    codiceStato: 'MP',
  },
  {
    stato: 'Norway',
    codiceStato: 'NO',
  },
  {
    stato: 'Oman',
    codiceStato: 'OM',
  },
  {
    stato: 'Pakistan',
    codiceStato: 'PK',
  },
  {
    stato: 'Palau',
    codiceStato: 'PW',
  },
  {
    stato: 'Palestinian Territories',
    codiceStato: 'PS',
  },
  {
    stato: 'Panama',
    codiceStato: 'PA',
  },
  {
    stato: 'Papua New Guinea',
    codiceStato: 'PG',
  },
  {
    stato: 'Paraguay',
    codiceStato: 'PY',
  },
  {
    stato: 'Peru',
    codiceStato: 'PE',
  },
  {
    stato: 'Philippines',
    codiceStato: 'PH',
  },
  {
    stato: 'Pitcairn Islands',
    codiceStato: 'PN',
  },
  {
    stato: 'Poland',
    codiceStato: 'PL',
  },
  {
    stato: 'Portugal',
    codiceStato: 'PT',
  },
  {
    stato: 'Puerto Rico',
    codiceStato: 'PR',
  },
  {
    stato: 'Qatar',
    codiceStato: 'QA',
  },
  {
    stato: 'Reunion',
    codiceStato: 'RE',
  },
  {
    stato: 'Romania',
    codiceStato: 'RO',
  },
  {
    stato: 'Russia',
    codiceStato: 'RU',
  },
  {
    stato: 'Rwanda',
    codiceStato: 'RW',
  },
  {
    stato: 'Saint Helena',
    codiceStato: 'SH',
  },
  {
    stato: 'Saint Kitts and Nevis',
    codiceStato: 'KN',
  },
  {
    stato: 'Saint Lucia',
    codiceStato: 'LC',
  },
  {
    stato: 'Saint Pierre and Miquelon',
    codiceStato: 'PM',
  },
  {
    stato: 'Saint Vincent and the Grenadines',
    codiceStato: 'VC',
  },
  {
    stato: 'Samoa',
    codiceStato: 'WS',
  },
  {
    stato: 'San Marino',
    codiceStato: 'SM',
  },
  {
    stato: 'Sao Tome and Principe',
    codiceStato: 'ST',
  },
  {
    stato: 'Saudi Arabia',
    codiceStato: 'SA',
  },
  {
    stato: 'Senegal',
    codiceStato: 'SN',
  },
  {
    stato: 'Serbia',
    codiceStato: 'RS',
  },
  {
    stato: 'Seychelles',
    codiceStato: 'SC',
  },
  {
    stato: 'Sierra Leone',
    codiceStato: 'SL',
  },
  {
    stato: 'Singapore',
    codiceStato: 'SG',
  },
  {
    stato: 'Slovakia',
    codiceStato: 'SK',
  },
  {
    stato: 'Slovenia',
    codiceStato: 'SI',
  },
  {
    stato: 'Solomon Islands',
    codiceStato: 'SB',
  },
  {
    stato: 'Somalia',
    codiceStato: 'SO',
  },
  {
    stato: 'South Africa',
    codiceStato: 'ZA',
  },
  {
    stato: 'South Georgia and the South Sandwich Islands',
    codiceStato: 'GS',
  },
  {
    stato: 'Spain',
    codiceStato: 'ES',
  },
  {
    stato: 'Sri Lanka',
    codiceStato: 'LK',
  },
  {
    stato: 'Sudan',
    codiceStato: 'SD',
  },
  {
    stato: 'Suriname',
    codiceStato: 'SR',
  },
  {
    stato: 'Svalbard',
    codiceStato: 'SJ',
  },
  {
    stato: 'Swaziland',
    codiceStato: 'SZ',
  },
  {
    stato: 'Sweden',
    codiceStato: 'SE',
  },
  {
    stato: 'Switzerland',
    codiceStato: 'CH',
  },
  {
    stato: 'Syria',
    codiceStato: 'SY',
  },
  {
    stato: 'Tajikistan',
    codiceStato: 'TJ',
  },
  {
    stato: 'Tanzania',
    codiceStato: 'TZ',
  },
  {
    stato: 'Thailand',
    codiceStato: 'TH',
  },
  {
    stato: 'Timor-Leste (East Timor)',
    codiceStato: 'TL',
  },
  {
    stato: 'Togo',
    codiceStato: 'TG',
  },
  {
    stato: 'Tokelau',
    codiceStato: 'TK',
  },
  {
    stato: 'Tonga',
    codiceStato: 'TO',
  },
  {
    stato: 'Trinidad and Tobago',
    codiceStato: 'TT',
  },
  {
    stato: 'Tristan da Cunha',
    codiceStato: 'TA',
  },
  {
    stato: 'Tunisia',
    codiceStato: 'TN',
  },
  {
    stato: 'Turkey',
    codiceStato: 'TR',
  },
  {
    stato: 'Turkmenistan',
    codiceStato: 'TM',
  },
  {
    stato: 'Turks and Caicos Islands',
    codiceStato: 'TC',
  },
  {
    stato: 'Tuvalu',
    codiceStato: 'TV',
  },
  {
    stato: 'U.S. Virgin Islands',
    codiceStato: 'VI',
  },
  {
    stato: 'Uganda',
    codiceStato: 'UG',
  },
  {
    stato: 'Ukraine',
    codiceStato: 'UA',
  },
  {
    stato: 'United Arab Emirates',
    codiceStato: 'AE',
  },
  {
    stato: 'United Kingdom',
    codiceStato: 'GB',
  },
  {
    stato: 'United States',
    codiceStato: 'US',
  },
  {
    stato: 'Uruguay',
    codiceStato: 'UY',
  },
  {
    stato: 'Uzbekistan',
    codiceStato: 'UZ',
  },
  {
    stato: 'Vanuatu',
    codiceStato: 'VU',
  },
  {
    stato: 'Vaticano',
    codiceStato: 'VA',
  },
  {
    stato: 'Venezuela',
    codiceStato: 'VE',
  },
  {
    stato: 'Viet Nam',
    codiceStato: 'VN',
  },
  {
    stato: 'Wallis and Futuna',
    codiceStato: 'WF',
  },
  {
    stato: 'Western Sahara',
    codiceStato: 'EH',
  },
  {
    stato: 'Yemen',
    codiceStato: 'YE',
  },
  {
    stato: 'Zambia',
    codiceStato: 'ZM',
  },
  {
    stato: 'Zimbabwe',
    codiceStato: 'ZW',
  },
].sort((a, b) => a.codiceStato.localeCompare(b.codiceStato));

export const listaLingue = [
  { lingua: 'Abcaso', codiceLingua: 'ab' },
  { lingua: 'Afar', codiceLingua: 'aa' },
  { lingua: 'Afrikaans', codiceLingua: 'af' },
  { lingua: 'Albanese', codiceLingua: 'sq' },
  { lingua: 'Amarico', codiceLingua: 'am' },
  { lingua: 'Arabo', codiceLingua: 'ar' },
  { lingua: 'Armeno', codiceLingua: 'hy' },
  { lingua: 'Assamese', codiceLingua: 'as' },
  { lingua: 'Aymara', codiceLingua: 'ay' },
  { lingua: 'Azerbaigiano', codiceLingua: 'az' },
  { lingua: 'Bangla', codiceLingua: 'bn' },
  { lingua: 'Baschiro', codiceLingua: 'ba' },
  { lingua: 'Basco', codiceLingua: 'eu' },
  { lingua: 'Bengalese', codiceLingua: 'bn' },
  { lingua: 'Bhutani', codiceLingua: 'dz' },
  { lingua: 'Bihari', codiceLingua: 'bh' },
  { lingua: 'Bislama', codiceLingua: 'bi' },
  { lingua: 'Bretone', codiceLingua: 'br' },
  { lingua: 'Bulgaro', codiceLingua: 'bg' },
  { lingua: 'Birmano', codiceLingua: 'my' },
  { lingua: 'Bielorusso', codiceLingua: 'be' },
  { lingua: 'Cambogiano (Khmer)', codiceLingua: 'km' },
  { lingua: 'Catalano', codiceLingua: 'ca' },
  { lingua: 'Cinese', codiceLingua: 'zh' },
  { lingua: 'Corso', codiceLingua: 'co' },
  { lingua: 'Croato', codiceLingua: 'hr' },
  { lingua: 'Ceco', codiceLingua: 'cs' },
  { lingua: 'Danese', codiceLingua: 'da' },
  { lingua: 'Olandese', codiceLingua: 'nl' },
  { lingua: 'Inglese', codiceLingua: 'en' },
  { lingua: 'Esperanto', codiceLingua: 'eo' },
  { lingua: 'Estone', codiceLingua: 'et' },
  { lingua: 'Faroese', codiceLingua: 'fo' },
  { lingua: 'Figiano', codiceLingua: 'fj' },
  { lingua: 'Finlandese', codiceLingua: 'fi' },
  { lingua: 'Francese', codiceLingua: 'fr' },
  { lingua: 'Frisone', codiceLingua: 'fy' },
  { lingua: 'Galiziano', codiceLingua: 'gl' },
  { lingua: 'Georgiano', codiceLingua: 'ka' },
  { lingua: 'Tedesco', codiceLingua: 'de' },
  { lingua: 'Greco', codiceLingua: 'el' },
  { lingua: 'Groenlandese', codiceLingua: 'kl' },
  { lingua: 'Guaraní', codiceLingua: 'gn' },
  { lingua: 'Gujarati', codiceLingua: 'gu' },
  { lingua: 'Hausa', codiceLingua: 'ha' },
  { lingua: 'Ebraico', codiceLingua: 'iw' },
  { lingua: 'Hindi', codiceLingua: 'hi' },
  { lingua: 'Ungherese', codiceLingua: 'hu' },
  { lingua: 'Islandese', codiceLingua: 'is' },
  { lingua: 'Indonesiano', codiceLingua: 'in' },
  { lingua: 'Interlingua', codiceLingua: 'ia' },
  { lingua: 'Interlingue', codiceLingua: 'ie' },
  { lingua: 'Inupiak', codiceLingua: 'ik' },
  { lingua: 'Gaelico irlandese', codiceLingua: 'ga' },
  { lingua: 'Italiano', codiceLingua: 'it' },
  { lingua: 'Giapponese', codiceLingua: 'ja' },
  { lingua: 'Giavanese', codiceLingua: 'jw' },
  { lingua: 'Kannada', codiceLingua: 'kn' },
  { lingua: 'Kashmiro', codiceLingua: 'ks' },
  { lingua: 'Kazako', codiceLingua: 'kk' },
  { lingua: 'Kinyarwanda', codiceLingua: 'rw' },
  { lingua: 'Kirghiso', codiceLingua: 'ky' },
  { lingua: 'Kirundi', codiceLingua: 'rn' },
  { lingua: 'Coreano', codiceLingua: 'ko' },
  { lingua: 'Curdo', codiceLingua: 'ku' },
  { lingua: 'Laotiano', codiceLingua: 'lo' },
  { lingua: 'Latino', codiceLingua: 'la' },
  { lingua: 'Lettone', codiceLingua: 'lv' },
  { lingua: 'Lettone', codiceLingua: 'lv' },
  { lingua: 'Lingala', codiceLingua: 'ln' },
  { lingua: 'Lituano', codiceLingua: 'lt' },
  { lingua: 'Macedone', codiceLingua: 'mk' },
  { lingua: 'Malgascio', codiceLingua: 'mg' },
  { lingua: 'Malese', codiceLingua: 'ms' },
  { lingua: 'Malayalam', codiceLingua: 'ml' },
  { lingua: 'Maltese', codiceLingua: 'mt' },
  { lingua: 'Maori', codiceLingua: 'mi' },
  { lingua: 'Marathi', codiceLingua: 'mr' },
  { lingua: 'Moldavo', codiceLingua: 'mo' },
  { lingua: 'Mongolo', codiceLingua: 'mn' },
  { lingua: 'Nauru', codiceLingua: 'na' },
  { lingua: 'Nepalese', codiceLingua: 'ne' },
  { lingua: 'Norvegese', codiceLingua: 'no' },
  { lingua: 'Occitano', codiceLingua: 'oc' },
  { lingua: 'Oriya (Odia)', codiceLingua: 'or' },
  { lingua: 'Oromo', codiceLingua: 'om' },
  { lingua: 'Pashto', codiceLingua: 'ps' },
  { lingua: 'Persiano', codiceLingua: 'fa' },
  { lingua: 'Polacco', codiceLingua: 'pl' },
  { lingua: 'Portoghese', codiceLingua: 'pt' },
  { lingua: 'Punjabi', codiceLingua: 'pa' },
  { lingua: 'Pashto', codiceLingua: 'ps' },
  { lingua: 'Quechua', codiceLingua: 'qu' },
  { lingua: 'Retoromanzo', codiceLingua: 'rm' },
  { lingua: 'Rumeno', codiceLingua: 'ro' },
  { lingua: 'Russo', codiceLingua: 'ru' },
  { lingua: 'Samoano', codiceLingua: 'sm' },
  { lingua: 'Sangro', codiceLingua: 'sg' },
  { lingua: 'Sanscrito', codiceLingua: 'sa' },
  { lingua: 'Gaelico scozzese', codiceLingua: 'gd' },
  { lingua: 'Serbo', codiceLingua: 'sr' },
  { lingua: 'Serbo-croato', codiceLingua: 'sh' },
  { lingua: 'Sesotho', codiceLingua: 'st' },
  { lingua: 'Tswana', codiceLingua: 'tn' },
  { lingua: 'Shona', codiceLingua: 'sn' },
  { lingua: 'Sindhi', codiceLingua: 'sd' },
  { lingua: 'Singalese', codiceLingua: 'si' },
  { lingua: 'Swati', codiceLingua: 'ss' },
  { lingua: 'Slovacco', codiceLingua: 'sk' },
  { lingua: 'Sloveno', codiceLingua: 'sl' },
  { lingua: 'Somalo', codiceLingua: 'so' },
  { lingua: 'Spagnolo', codiceLingua: 'es' },
  { lingua: 'Sundanese', codiceLingua: 'su' },
  { lingua: 'Swahili', codiceLingua: 'sw' },
  { lingua: 'Svedese', codiceLingua: 'sv' },
  { lingua: 'Tagalog', codiceLingua: 'tl' },
  { lingua: 'Tagico', codiceLingua: 'tg' },
  { lingua: 'Tamil', codiceLingua: 'ta' },
  { lingua: 'Tataro', codiceLingua: 'tt' },
  { lingua: 'Telugu', codiceLingua: 'te' },
  { lingua: 'Thai', codiceLingua: 'th' },
  { lingua: 'Tibetano', codiceLingua: 'bo' },
  { lingua: 'Tigrino', codiceLingua: 'ti' },
  { lingua: 'Tongano', codiceLingua: 'to' },
  { lingua: 'Tsonga', codiceLingua: 'ts' },
  { lingua: 'Turco', codiceLingua: 'tr' },
  { lingua: 'Turkmeno', codiceLingua: 'tk' },
  { lingua: 'Twi', codiceLingua: 'tw' },
  { lingua: 'Ucraino', codiceLingua: 'uk' },
  { lingua: 'Urdu', codiceLingua: 'ur' },
  { lingua: 'Uzbeko', codiceLingua: 'uz' },
  { lingua: 'Vietnamita', codiceLingua: 'vi' },
  { lingua: 'Volapük', codiceLingua: 'vo' },
  { lingua: 'Gallese', codiceLingua: 'cy' },
  { lingua: 'Wolof', codiceLingua: 'wo' },
  { lingua: 'Xhosa', codiceLingua: 'xh' },
  { lingua: 'Yiddish', codiceLingua: 'ji' },
  { lingua: 'Yoruba', codiceLingua: 'yo' },
  { lingua: 'Zulu', codiceLingua: 'zu' },
];
